import React from 'react';
import Popover from '@material-ui/core/Popover';
import { ThemeProvider } from '@material-ui/core/styles';
import { PopoverOrigin } from '@material-ui/core/Popover';
import globalMaterialUITheme from '../../../../../@alo/yoga-ui';
import styles from './styles.module.scss';

type TooltipTypes = {
  children?: JSX.Element;
  isOpen: boolean;
  anchorOriginProps: PopoverOrigin;
  transformOriginProps: PopoverOrigin;
  anchorElement: Element;
  disableScrollLock?: boolean;
  isMouseHover?: boolean;
  position?: Position;
  colorScheme?: ColorScheme;
  pointerPosition?: PointerPosition;
  customClasses?: string;
};

type ColorScheme = 'dark' | 'light';
type Position = 'top' | 'bottom';
type PointerPosition = { horizontal: 'left' | 'center' };

const Tooltip = ({
  isOpen,
  children,
  position = 'bottom',
  colorScheme = 'light',
  pointerPosition = { horizontal: 'left' },
  customClasses = '',
  anchorOriginProps = {
    vertical: 0,
    horizontal: 0,
  },
  transformOriginProps = {
    vertical: 0,
    horizontal: 0,
  },
  anchorElement,
  isMouseHover = false,
  disableScrollLock = true,
}: TooltipTypes) => {
  const positionClass = position === 'top' ? styles.paperTop : styles.paperBottom;
  const pointerClass = pointerPosition.horizontal === 'center' ? styles.paperCenter : styles.paperLeft;
  const themeClass = colorScheme === 'dark' ? styles.darkTheme : styles.lightTheme;

  return (
    <ThemeProvider theme={globalMaterialUITheme}>
      <Popover
        className={isMouseHover ? `${styles.popover} ${customClasses}` : customClasses}
        classes={{
          root: styles.popoverRoot,
          paper: `${styles.paper} ${positionClass} ${pointerClass} ${themeClass}`,
        }}
        open={isOpen}
        anchorOrigin={anchorOriginProps}
        transformOrigin={transformOriginProps}
        anchorEl={anchorElement}
        disableScrollLock={disableScrollLock}
        disableRestoreFocus={true}
      >
        {children}
      </Popover>
    </ThemeProvider>
  );
};

export default Tooltip;
